var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"connectors"},[_c('Connector',{ref:"connector",on:{"vscode":function (v) { _vm.vs = v; },"fscode":function (v) { _vm.fs = v; }}})],1),_vm._v(" "),_c('div',{ref:"canvas-area",staticClass:"canvas-area"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775d4a50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/shader-gui/ShaderGUI.vue
// module id = 487
// module chunks = 2